module.exports = __webpack_public_path__ + "media/MRI7C.fc8ff944.mp3";